import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Sort } from '@angular/material';
// import { MatTableDataSource } from '@angular/material';
@Component({
  selector: 'vernost-table',
  templateUrl: "./vernost-table.html",
  styleUrls: ["./vernost-list.scss"]
})

export class VernostTableComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input('listtitle') listtitle: string;
  @Input('filterreq') filterreq: boolean;
  @Input('additionalactions') additionalactions: any;
  @Input('actionbuttonreq') actionbuttonsreq: boolean;
  @Input('editactionbuttonreq') editactionbuttonreq: boolean;
  @Input('viewactionbuttonreq') viewactionbuttonreq: boolean;
  //@Input('dataSource') 
  dataSourcevalue: any;
  displayedCells: any;
  displayedCellTitles: any;
  @Input('displayedColumns')
  set displayedColumns(value: any) {
    if (this.actionbuttonsreq) {
      if (value != null) {
        if (value != undefined) {
          let pvalue: any = [];
          pvalue.push("Action");
          value.forEach((el: any) => {
            pvalue.push(el);
          });
          this.displayedCells = pvalue;
        }
      }
    } else {
      this.displayedCells = value;
    }
  }

  get displayedColumns() {
    return this.displayedCells;
  }

  @Input('displayedColumnTitles')
  set displayedColumnTitles(value: any) {
    if (this.actionbuttonsreq) {
      if (value != null) {
        if (value != undefined) {
          let pvalue: any = [];
          pvalue.push("Action");
          value.forEach((el: any) => {
            pvalue.push(el);
          });
          this.displayedCellTitles = pvalue;
        }
      }
    } else {
      this.displayedCellTitles = value;
    }
  }

  get displayedColumnTitles() {
    return this.displayedCellTitles;
  }

  @Input('dataSource')
  set dataSource(value: any) {
    if (value != null) {
      if (value != undefined) {
        value.forEach((e: any) => {
          e.action = "";
        });
        this.dataSourcevalue = new MatTableDataSource(value);
        this.dataSourcevalue.paginator = this.paginator;
        this.dataSourcevalue.sort = this.sort;
      }
    }
  }

  @Output() SelectedItem: EventEmitter<any> = new EventEmitter<any>();

  get dataSource() {
    return this.dataSourcevalue;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSourcevalue.filter = filterValue;
  }

  constructor() {

  }

  ngOnInit() {
    this.dataSourcevalue.paginator = this.paginator;
    this.dataSourcevalue.sort = this.sort;
  }
  trclick(element: any, type: string) {
    this.SelectedItem.emit(
      { type: type, data: element });
  }
}
